import  {  Dispatch, SetStateAction, useEffect } from "react";


export const useOutsideAction = (ref: any, setIsOpen: Dispatch<SetStateAction<boolean>>) => {
    useEffect(() => {
        /**
         * Alert if clicked on outside of element
         */
        function handleClickOutside(event: MouseEvent) {
            if (ref.current && !ref.current.contains(event.target)) {
                setIsOpen(false);
                // alert("CLICK OUTSIDE")
            }
        }

        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref]);
}